import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_PATHS } from '../constants/app-routes';
import { canManageRoutes } from '../constants/roles';
import { AuthService } from '../services/auth.service';

/** Master, Admin e Líder podem acessar gestão de usuários (escopo filtrado na API). */
export const userManagementGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.getToken()) {
    return router.createUrlTree([APP_PATHS.login]);
  }

  const current = auth.user();
  if (canManageRoutes(current?.role)) {
    return true;
  }

  return auth.loadProfile().pipe(
    map((user) =>
      canManageRoutes(user?.role) ? true : router.createUrlTree([APP_PATHS.myRoute])
    )
  );
};
